import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { PriceHelper } from 'app/shared/price-helper';
import { CartService } from '../../../services/cart/cart.service';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { DialogPriceChangedComponent } from 'app/pages/products/dialog-price-changed/dialog-price-changed.component';
import { Order } from 'app/models/order/order';
import { OrderItem } from 'app/models/order/order-item';
import { CartProduct } from 'app/models/product/cart-product/cart-product';

@Component({
  selector: 'ultra-dialog-change-order',
  templateUrl: './dialog-change-order.component.html',
  styleUrls: ['./dialog-change-order.component.scss'],
})
export class DialogChangeOrderComponent implements OnInit {

  constructor(
    protected dialogRef: NbDialogRef<DialogChangeOrderComponent>,
    private cartService: CartService,
    private router: Router,
    private dialogService: NbDialogService,
    private priceHelper: PriceHelper,
  ) { }

  order: Order;

  message: string = 'Já Existem Itens adicionados ao carrinho. O que deseja fazer?';
  okMessage: string = 'Substituir e Continuar Compra';
  cancelMessage: string = 'Não Substituir';
  titleMessage: string = 'Continuar Comprando';

  ngOnInit() {
  }

  keepBuying() {
    if (this.order && this.order.items.length > 0) {
      this.cartService.clearCart();
      this.addProductsToCart(this.order);
    }
    this.close(true);    
  }

  addProductsToCart(order: Order) {
    this.priceHelper.checkOrderPrices(order).then((data) => {
      
      // if (data && data.length > 0) {

      //   this.dialogService.open(DialogPriceChangedComponent, {
      //     context: {
      //       changedPrices: data,
      //     },
      //     closeOnBackdropClick: false,
      //     closeOnEsc: false,
      //   }).onClose.subscribe((changedItems: any[]) => {
      //     this.loadOrder(order, changedItems);
      //     this.router.navigate(['pages/products']);
      //   });
      // } else {
      //   this.loadOrder(order);
      //   this.router.navigate(['pages/products']);
      // }
    });
  }

  loadOrder(order: Order, data = null) {
    // order.items.map((el: OrderItem) => {
    //   // Ao zerar a quantidade, o produto é removido do carrinho
    //   if (data) {
    //     if (data.filter(n => n.id === el.productId && !n.keep).length > 0) {
    //       el. .quantity = 0;
    //     } else {
    //       el.product.quantity = parseFloat(el.quantity);
    //     }
    //   } else {
    //     el.product.quantity = parseFloat(el.quantity);
    //   }

    //   el.product.measureQuantity = parseFloat(el.measureUnitQuantity);
    //   el.product.unitMeasureSelected = el.measurementUnit;
    //   el.product.measurementUnit = el.measurementUnit;
    //   if (el.product.measurementUnitProducts.length > 0) {
    //     el.product.measurementUnitProducts.find(measure => {
    //       if (el.measurementUnit.id == measure.measurementUnit.id) {
    //         el.product.index = measure.index;
    //       }
    //     });
    //   } else {
    //     el.product.index = 1;
    //   }
    //   //this.cartService.updateProduct(el.product);
    // });

    // sessionStorage.setItem('currentOrder', JSON.stringify(order));
    // this.router.navigate(['pages/products']);
  }

  close(status) {
    this.dialogRef.close(status);
  }
}
